import { render, staticRenderFns } from "./celldatail.vue?vue&type=template&id=01f0fd70&scoped=true&"
import script from "./celldatail.vue?vue&type=script&lang=js&"
export * from "./celldatail.vue?vue&type=script&lang=js&"
import style0 from "./celldatail.vue?vue&type=style&index=0&id=01f0fd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0fd70",
  null
  
)

export default component.exports